import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as d3 from "d3";
import { connect } from "react-redux";
import WithCard from "../../../common/withCard";
import Liveholdings from "./LiveHoldings/liveholdings";
import LiveAsset from "./LiveAsset/LiveAsset";
import Spinner from "../Datatable/spinner/spinner";
import AssetClassHolder from "./AssetClass/AssetClassHolder";
import StyleExposureHolder from "./StyleExposure/styleExposureHolder";
import DownloadPdfButton from "../../../common/buttons/downloadPdfButton";
// import RebalanceDashboard from "./RebalancingDashboard/rebalanceDashboard";
// import Exposure from "../Component page/AssetClass/section1/exposure";
// import SkittleHolder from '../Component page/AssetClass/section1/skittleHolder';
// import AreaChartHolder from './AssetClass/section1/areaChartHolder';
import {
  StyleSheet,
  Image as IMG,
  View,
  Document,
  Page,
  Text,
  pdf,
} from "@react-pdf/renderer";
// import { PdfContainer } from "../../../parts/pdfmaker/pdfHolder";
import PdfTable from "../../../parts/pdfmaker/common/pdfTable";
import PdfHeader from "../../../parts/pdfmaker/common/pdfHeader";
import ScrollToTopOnMount from "../../../parts/ScrollToTopOnMount";
import PDFHelper from "../../../parts/pdfmaker/pdf.helper";
import Helper from "./helper";
import { pdfStyles, pdfcolors } from "./pdf.styles";
import "../../../pages/Portfolio";
import "./component.scss";

class Comptab extends Component {
  state = {
    listOfDropDownDates: [],
    res: {},
    portfolioData: {},
    portfolioFilter: [],
    allDatesForSelect: [],
    getPortfolioData: [],
    selectedPortfolioDate: "",
    returnDt_dt_pair: {},
    newData: [],
    PieData: [],
    newPieData: [],
    spinner: true,
    errorCatched: false,
    imgAddress: null,
    pdfStyleTableHeading: [
      { title: "Style Exposure" },
      { title: "Weight (%)" },
    ],
    pdfTableHeading: [
      { title: "Symbol" },
      { title: "Name" },
      { title: "Asset Class" },
      { title: "Style" },
      { title: "Weight (%)" },
      { title: "Returns (%)" },
    ],
    activeAssetClassChartID: "asset_class_stock_place",
    activeStyleChartID: "asset_class_stock_place2",
    selectedModel: "IQCIO Portfolio",
  };

  componentDidMount() {
    const { getBacktest } = this.props;
    if (getBacktest) {
      this.modifyData(getBacktest);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.getBacktest) {
      let old_getPortfolioData = JSON.stringify(
        this.props.getBacktest.getPortfolioData
      );
      let new_getPortfolioData = JSON.stringify(
        nextProps.getBacktest.getPortfolioData
      );
      if (old_getPortfolioData !== new_getPortfolioData) {
        this.modifyData(nextProps.getBacktest);
      }
    }

    // if (this.props.scenario_id !== nextProps.scenario_id) {
    this.setState({
      selectedModel: "IQCIO Portfolio",
    });
    // }
  }

  componentDidCatch(error, info) {
    this.setState({
      errorCatched: true,
    });
  }

  modifyData = (getBacktest) => {
    let portfolioFilter = [];
    let portfolioData = {};
    let PieData = [];
    let arrayOfDates = [];
    let listOfDropDownDates = {};
    let returnDt_dt_pair = {};

    const { getPortfolioData } = getBacktest;
    for (let i in getPortfolioData) {
      let line = getPortfolioData[i];
      if (
        +i === 0 ||
        (portfolioFilter[portfolioFilter.length - 1] &&
          portfolioFilter[portfolioFilter.length - 1].value !== line.dt)
      ) {
        portfolioFilter.push({
          value: line.dt,
        });
        arrayOfDates.push(line.dt);
        listOfDropDownDates[line.return_dt] = {
          value: line.return_dt,
          dt: line.dt,
        };
        returnDt_dt_pair[line.return_dt] = line.dt;
      }

      line.dt in portfolioData
        ? portfolioData[line.dt].push([
            line.symbol,
            line.fund_name,
            line.fund_asset_class_focus,
            line.style,
            line.allocation,
            // line.style,
            (line.monthly_return * 100).toFixed(2),
          ])
        : (portfolioData[line.dt] = [
            [
              line.symbol,
              line.fund_name,
              line.fund_asset_class_focus,
              line.style,
              line.allocation,
              // line.style,
              (line.monthly_return * 100).toFixed(2),
            ],
          ]);

      line.dt in PieData
        ? PieData[line.dt].push({
            fund: line.fund_asset_class_focus,
            allocation: line.allocation * 1,
            style: line.style,
          })
        : (PieData[line.dt] = [
            {
              fund: line.fund_asset_class_focus,
              allocation: line.allocation * 1,
              style: line.style,
            },
          ]);
    }

    let newData = [];
    let newPieData = [];
    let defaultDate = "";

    if (arrayOfDates.length > 0) {
      let last_date = arrayOfDates[arrayOfDates.length - 1];

      newData = portfolioData[last_date];
      newPieData = PieData[last_date];

      let lastDateOfReturn = Object.values(listOfDropDownDates);

      defaultDate = lastDateOfReturn[lastDateOfReturn.length - 1].value;
    }

    this.setState({
      listOfDropDownDates: Object.values(listOfDropDownDates),
      portfolioFilter,
      portfolioData,
      PieData,
      newData,
      newPieData,
      selectedPortfolioDate: defaultDate,
      res: getBacktest,
      getPortfolioData: getBacktest.getPortfolioData,
      spinner: false,
      returnDt_dt_pair,
    });
  };
  changePortfolioDate = (e) => {
    e.preventDefault();
    const { returnDt_dt_pair } = this.state;
    let { value } = e.target;

    let return_dt = e.target.value;
    let dt = returnDt_dt_pair[return_dt];

    console.log({ return_dt: value, dt });
    this.setState({
      selectedPortfolioDate: return_dt,
    });
    setTimeout(() => this.cngHandler(dt), 0);
  };

  cngHandler = (value) => {
    const { portfolioData, PieData } = this.state;

    let newData = portfolioData[value];
    let newPieData = PieData[value];

    this.setState({
      newData,
      newPieData,
    });
    this.forceUpdate();
  };

  assetHamburgerHandler = (id) => {
    let ID = id === "skittleChart" ? "asset_class_stock_place" : id;
    this.setState({
      activeAssetClassChartID: ID,
    });
  };

  styleHamburgerHandler = (id) => {
    let ID = id === "skittleChart" ? "asset_class_stock_place2" : id;
    this.setState({
      activeStyleChartID: ID,
    });
  };

  modelSelectionHandler = (e) => {
    let { value } = e.target;
    this.setState({
      selectedModel: value,
    });

    if (value === "IQCIO Portfolio") {
      this.modifyData(this.props.getBacktest);
      this.forceUpdate();
    } else if (value === "Your Portfolio") {
      this.modifyData(this.props.clientBacktestData);
      this.forceUpdate();
    }
  };

  exportToPDF = () => {
    const { heading } = this.props;
    // get legends data;
    var styleLegends = new Promise((resolve) =>
      resolve(Helper.styleFormatData(this.state.res))
    );
    var assetClassLegends = new Promise((resolve) =>
      resolve(Helper.assetFormatData(this.state.res))
    );

    Promise.allSettled([
      PDFHelper.svgToPng("Pie1"),
      PDFHelper.svgToPng("Treemap1"),
      PDFHelper.svgToPng(this.state.activeAssetClassChartID),
      PDFHelper.svgToPng(this.state.activeStyleChartID),
      styleLegends,
      assetClassLegends,
    ]).then((values) => {
      const styles = StyleSheet.create({
        ...pdfStyles,
      });

      var newObj = {};
      var { newPieData } = this.state;

      for (let i in newPieData) {
        if (!newObj[newPieData[i]["style"]]) {
          newObj[newPieData[i]["style"]] = newPieData[i]["allocation"] * 1;
        } else {
          newObj[newPieData[i]["style"]] =
            parseFloat(newObj[newPieData[i]["style"]]) +
            parseFloat(newPieData[i]["allocation"]);
        }
      }
      const StyleTable = (data, heading) => {
        return (
          <Fragment>
            <View style={styles.table}>
              <View
                style={{
                  margin: "auto",
                  flexDirection: "row",
                  backgroundColor: "#d4d7de",
                }}
              >
                {heading.map((e, i) => {
                  return (
                    <View style={styles.tableColHeader} key={i}>
                      <Text style={styles.tableCellHeader}>{e.title}</Text>
                    </View>
                  );
                })}
              </View>
            </View>
            {Object.keys(data).map((e, i) => {
              return (
                <View
                  style={[
                    styles.tableRow,
                    i % 2 === 0 ? styles.one : styles.two,
                  ]}
                  key={i}
                >
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{e}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{data[e].toFixed(2)}</Text>
                  </View>
                </View>
              );
            })}
          </Fragment>
        );
      };
      const Legend = (data) => {
        var color = [...pdfcolors];
        var colors = d3.scale.ordinal().range(color);
        const clr = function (d, i) {
          return colors(i);
        };

        return data.map((d, i) => (
          <View
            key={i}
            style={{
              display: "flex",
              flexDirection: "row",
              marginRight: 2,
              alignItems: "center",
            }}
          >
            <Text
              style={{
                backgroundColor: `${clr(d, i)}`,
                borderRadius: 50,
                width: 6,
                height: 6,
                paddingRight: 4,
              }}
            >
              0
            </Text>
            <Text
              style={{
                fontSize: 8,
                color: "#333333",
                marginLeft: 2,
                marginRight: 2,
              }}
            >{`${d.name}`}</Text>
          </View>
        ));
      };
      const MyDoc = () => (
        <Document>
          <Page size="A4" wrap style={styles.pb}>
            <PdfHeader mainHeading={heading + " - " + "COMPONENT"} />
            {values[0] && values[0].value ? (
              <View style={styles.paddingHorizontal}>
                <View
                  style={{
                    color: "#223279",
                    textAlign: "center",
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  <Text>HOLDINGS AND ASSET CLASS EXPOSURE</Text>
                </View>
                <View>
                  <IMG source={values[0].value}></IMG>
                </View>
                <PdfTable
                  data={this.state.newData}
                  heading={this.state.pdfTableHeading}
                  Width="20%"
                />
              </View>
            ) : null}
          </Page>
          {values[1] && values[0].value ? (
            <Page size="A4" wrap style={styles.pb}>
              <View style={styles.paddingHorizontal}>
                <View
                  style={{
                    color: "#223279",
                    textAlign: "center",
                    paddingTop: 50,
                    paddingBottom: 15,
                  }}
                >
                  <Text>STYLE EXPOSURES</Text>
                  <IMG source={values[1].value}></IMG>
                </View>
                {StyleTable(newObj, this.state.pdfStyleTableHeading)}
              </View>
            </Page>
          ) : null}
          <Page size="A4" wrap style={styles.pb}>
            <View style={styles.paddingHorizontal}>
              {values[2] && values[2].value ? (
                <View
                  style={{
                    color: "#223279",
                    textAlign: "center",
                    paddingTop: 50,
                    paddingBottom: 5,
                  }}
                >
                  <Text>ASSET CLASS EXPOSURE</Text>
                  <IMG source={values[2].value}></IMG>
                </View>
              ) : null}
              <Fragment>
                {values[5] && values[5].value ? (
                  <View style={styles.flex}>
                    {this.state.activeAssetClassChartID === "multi1"
                      ? Legend(values[5].value)
                      : null}
                  </View>
                ) : null}
              </Fragment>
              {values[3] && values[3].value ? (
                <View
                  style={{
                    color: "#223279",
                    textAlign: "center",
                    paddingTop: 25,
                    paddingBottom: 5,
                  }}
                >
                  <Text>STYLE EXPOSURE</Text>
                  <IMG source={values[3].value}></IMG>
                </View>
              ) : null}
              <Fragment>
                {values[4] && values[4].value ? (
                  <View style={styles.flex}>
                    {this.state.activeStyleChartID === "multi2"
                      ? Legend(values[4].value)
                      : null}
                  </View>
                ) : null}
              </Fragment>
            </View>
          </Page>
        </Document>
      );

      pdf(<MyDoc />)
        .toBlob()
        .then((blob) => {
          const link = document.createElement("a");
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = "components.pdf";
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
        });
    });
  };

  render() {
    const {
      listOfDropDownDates,
      newPieData,
      newData,
      selectedPortfolioDate,
      spinner,
      res,
      selectedModel,
      pdfTableHeading,
    } = this.state;
    const { display_orig_portfolio } = this.props;

    const Error = <div>No data to display </div>;

    return (
      <Fragment>
        <ScrollToTopOnMount />
        <Fragment>
          <WithCard>
            {spinner ? (
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="d-flex justify-content-center">
                    <Spinner />
                  </div>
                </div>
              </div>
            ) : (
              <Fragment>
                {(newPieData && newPieData.length > 0) ||
                (listOfDropDownDates && listOfDropDownDates.length > 0) ? (
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 as_of_label_holder">
                      <div>
                        <label className="text-uppercase bold asOflabel">
                          as of &nbsp;
                        </label>

                        <select
                          className="bg-white text-dark p-all"
                          value={selectedPortfolioDate}
                          onChange={this.changePortfolioDate}
                        >
                          {listOfDropDownDates.map((o, i) => (
                            <option key={i} value={o.value}>
                              {o.value}
                            </option>
                          ))}
                        </select>
                      </div>
                      {display_orig_portfolio ? (
                        <div>
                          <select
                            name="select_model"
                            id="select_model"
                            onChange={this.modelSelectionHandler}
                            value={selectedModel}
                          >
                            <option value="IQCIO Portfolio">
                              IQCIO Portfolio
                            </option>
                            <option value="Your Portfolio">
                              Your Portfolio
                            </option>
                          </select>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 my-auto component_pdf_btn">
                      <DownloadPdfButton handler={this.exportToPDF} />
                    </div>
                  </div>
                ) : (
                  Error
                )}
              </Fragment>
            )}
          </WithCard>
          <WithCard>
            {/* {this.state.imgAddress !== null ? (
            <img src={`${this.state.imgAddress}`}></img>
          ) : null} */}
            {newPieData && newPieData.length ? (
              <Liveholdings
                newPieData={newPieData}
                newData={newData}
                tableHeading={pdfTableHeading}
              />
            ) : null}
          </WithCard>
          <div className="row">
            {newPieData && newPieData.length ? (
              <LiveAsset newPieData={newPieData} />
            ) : null}
          </div>
          {/* multi line chart - Exposure */}
          {/* <div>{res ? <Exposure res={res} /> : null}</div> */}

          {/* Skittle chart goes here */}
          {/* {
          this.state.errorCatched === false ? 
            <div>{Object.keys(res).length && res.getPortfolioData.length > 0 ? <SkittleHolder res={res}/> : null}</div>
          : null 
        }  */}
          {/* <div>
          {Object.keys(res).length ? <AreaChartHolder res={res}/> : null }
        </div> */}
          {/* <WithCard>
          {getPortfolioData.length ? <RebalanceDashboard scenario_id={scenario_id} {...this.props} getPortfolioData={getPortfolioData}/> : null }
        </WithCard> */}
          {/* have to delete file later */}

          {Object.keys(res).length && res.getPortfolioData.length > 0 ? (
            <AssetClassHolder
              res={res}
              assetHamburgerHandler={this.assetHamburgerHandler}
            />
          ) : null}
          {Object.keys(res).length && res.getPortfolioData.length > 0 ? (
            <StyleExposureHolder
              res={res}
              styleHamburgerHandler={this.styleHamburgerHandler}
            />
          ) : null}
        </Fragment>
      </Fragment>
    );
  }
}

Comptab.propTypes = {
  scenario_id: PropTypes.number,
  heading: PropTypes.string,
  display_orig_portfolio: PropTypes.bool,
  getBacktest: PropTypes.object.isRequired,
  clientBacktestData: PropTypes.object,
};
export default connect(
  ({
    create: {
      steps: {
        risk: { display_orig_portfolio },
        universeLite: {
          analyze_compare: { clientBacktestData },
        },
      },
    },
  }) => ({
    display_orig_portfolio,
    clientBacktestData,
  }),
  null
)(Comptab);



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/component.jsx